import React, { FC, ComponentType, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Route, Routes } from "react-router-dom";
import {isAdminAuthorised} from "Redux/Slices/Auth";
import {AppDispatch} from "Redux/Store";
import PublicLayout from "./PublicLayout";
import SignIn from "Components/SignIn/SignIn";
import {AppRoutes} from "../Routes/Routes";
import { TokenService } from 'Utilities/TokenService';

export interface IWithAuthentication {
    navigate?: (to: string, options: any) => void;
    dispatch?: AppDispatch;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {}

const withAuthentication = <ComponentProps extends Props>(WrappedComponent: ComponentType<ComponentProps & Props>) => {

    const WithProtectedWrapper:FC<ComponentProps & Props> = (props) => {

        const isLogin = useSelector(isAdminAuthorised);
        const dispatch: AppDispatch = useDispatch();

        const navigate = useNavigate();

        useEffect(() => {
            if(!isLogin || !TokenService.getAccessToken()) {
                navigate(AppRoutes.login);
            }
            else {
                navigate(AppRoutes.dashboard); 
            }
        }, [isLogin]);

        if(!isLogin || !TokenService.getAccessToken()){
            return (
                <Routes>
                    <Route path={`/${AppRoutes.login}`} element={
                        <PublicLayout isLogin={false}>
                            <SignIn isLogin={false} />
                        </PublicLayout>
                    } />
                </Routes>
            );
        }

        return <WrappedComponent {...props} dispatch={dispatch} navigate={navigate} />;
    };

    return WithProtectedWrapper;

};

export default withAuthentication;